<div class="snackbar typography-footnote1" [ngClass]="type">
  <div class="left">
    <span class="data">{{ message | translate }} </span>
    <div class="line"></div>
  </div>
  <span class="right typography-caption" (click)="close()">{{
    "snackbar.close" | translate
  }}</span>
</div>
